export const theme = {
  primary: {
    6: '#0057ff',
    5: '#4D89FF',
    4: '#80ABFF',
    3: '#A6C4FF',
    2: '#B2CDFF',
    1: '#E5EEFF'
  },
  gray: {
    black: '#1F1E23',
    500: '#787878',
    400: '#9C9C9C',
    300: '#CCCCCC',
    250: '#BCBCBC',
    200: '#D9D9D9',
    100: '#E6E6E6',
    50: '#F6F6F8',
    white: '#FFF'
  },
  sub: {
    red: '#FF6B6B'
  }
};
